import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const CompletedCheckIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M3.25 18V6C3.25 5.27065 3.53994 4.57139 4.05566 4.05566C4.57139 3.53994 5.27065 3.25 6 3.25H15C15.4142 3.25 15.75 3.58579 15.75 4C15.75 4.41421 15.4142 4.75 15 4.75H6C5.66848 4.75 5.35063 4.88179 5.11621 5.11621C4.88179 5.35063 4.75 5.66848 4.75 6V18C4.75 18.3315 4.88179 18.6494 5.11621 18.8838C5.35063 19.1182 5.66848 19.25 6 19.25H18C18.3315 19.25 18.6494 19.1182 18.8838 18.8838C19.1182 18.6494 19.25 18.3315 19.25 18V12C19.25 11.5858 19.5858 11.25 20 11.25C20.4142 11.25 20.75 11.5858 20.75 12V18C20.75 18.7293 20.4601 19.4286 19.9443 19.9443C19.4286 20.4601 18.7293 20.75 18 20.75H6C5.27065 20.75 4.57139 20.4601 4.05566 19.9443C3.53994 19.4286 3.25 18.7293 3.25 18ZM19.4688 5.46973C19.7616 5.17686 20.2364 5.17691 20.5293 5.46973C20.8222 5.76262 20.8222 6.23738 20.5293 6.53027L12.5293 14.5303C12.2364 14.823 11.7616 14.8231 11.4688 14.5303L8.46875 11.5303C8.17597 11.2374 8.176 10.7626 8.46875 10.4697C8.76162 10.1769 9.2364 10.1769 9.5293 10.4697L11.999 12.9395L19.4688 5.46973Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
};

export default CompletedCheckIcon;
